import FormattedMessage from 'I18n/components/FormattedMessage';
import { getTypeAction, UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
function PendingApprovalButtonI18nTitleApprover(props) {
  const {
    approvalType,
    approvalAction
  } = props;
  const typeAction = getTypeAction(approvalType, approvalAction);
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.MARKETING_EMAIL-PUBLISH.APPROVER"
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.LANDING_PAGE-PUBLISH.APPROVER"
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.SITE_PAGE-PUBLISH.APPROVER"
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.BLOG_POST-PUBLISH.APPROVER"
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.DEAL-MOVE_STAGE.APPROVER"
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.KNOWLEDGE_ARTICLE-PUBLISH.APPROVER"
        });
      }
    default:
      throw new UnreachableI18nCaseError(typeAction);
  }
}
export default PendingApprovalButtonI18nTitleApprover;